<template>
  <div id="app">
    <DeviseModal />
    <TermsOfUseModal />
    <ModalIframe />

    <router-view />

  </div>
</template>

<script>
  import DeviseModal from "./components/devise/Modal.vue";
  import TermsOfUseModal from "./components/devise/TermsOfUse.vue";
  import ModalIframe from "./components/ModalIframe.vue";

  export default {
    components: {
      DeviseModal,
      TermsOfUseModal,
      ModalIframe
    },

    created() {
      // Se o id do primeiro estado não for um inteiro, quer dizer que está usando uma listagem de estados antiga, então devemos zerar para poder usar a nova
      let oldStates = localStorage.getItem('states');
      if (oldStates) {
        if (isNaN(JSON.parse(oldStates)[0]['id'])) {
          localStorage.removeItem('states')
        }
      }

      this.$store.dispatch("domains/getLocalDomains");
      this.$store.dispatch("location/setUserLocation", this.$geoip2);
      this.$store.dispatch("location/setStates");
      this.$store.dispatch("user/checkAuth");

      this.$EventBus.$on('checkTermsOfUse', () => {
        this.termsOfUse();
      });

      this.termsOfUse();
      this.hasSource();
    },

    destroyed() {
      this.$EventBus.$off('checkTermsOfUse');
    },

    methods: {
      termsOfUse(){
        if (this.$store.state.user.profile &&
            localStorage.getItem('termsOfUseAccepted') &&
            localStorage.getItem('termsOfUseAccepted') == 'false'
        ) {
          setTimeout(() => this.$EventBus.$emit('showTermsOfUse'), 50)
        }
      },

      hasSource() {
        if (this.$route.query.source && this.$route.params.id) {
          localStorage.setItem("source", this.$route.query.source);
          localStorage.setItem("sourceOpportunityId", this.$route.params.id);
        }
      }
    },
  };
</script>

<style lang="scss">
  @import "./assets/stylesheets/app.scss";
  
  #app > .container-fluid {
    min-height: 80vh;
  }
</style>
